/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from 'react';
import * as CustomWidgets from '.';
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';
import { makeStyles, createStyles } from '@mui/styles';
import { Button, ButtonGroup, Card, CardContent, CardHeader, Checkbox, Divider, FormControl, Grid, IconButton, InputLabel, List, ListItem, ListItemIcon, ListItemText, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Tooltip, Typography } from '@mui/material';
import { Add, Build, Edit, EditAttributes, Remove, Settings } from '@mui/icons-material';
import ReactJson from "react-json-view";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        titlesTabs: {
            textRendering: "geometricPrecision",
            WebkitFontSmoothing: "antialiased !important",
            scrollBehavior: "smooth",
            fontFamily: "Muli,sans-serif !important",
            color: "#969BA0 !important",
            //fontWeight: 'bold'
        },
        contentTab: {
            padding: "10px !important",
        },
        firstTitle: {
            padding: "16px",
        },
        titleTable: {
            display: "flex",
            width: "100%",
        },
        buttonAdd: {
            marginLeft: "88% !important",
        },
        titleH2: {
            display: "flex",
        },
        iconTitle: {
            marginTop: "4px",
            marginRight: "5px",
        },
        textField: {
            marginLeft: theme.spacing(1),
            display: "flex !important",
            width: "25% !important",
            margin: "auto !important",
            marginRight: "0 !important",
        },
    })
);

const IntentsConfig = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const [rol, setRol] = useState({});
    const [inList, setInList] = useState([]);
    const [exList, setExList] = useState([]);
    const [disabledAdd, setDisabledAdd] = useState(true);
    const [disabledRem, setDisabledRem] = useState(true);
    const [disabledEdit, setDisabledEdit] = useState(true);
    const [selectedIntent, setSelectedIntent] = useState({});
    const [factor, setFactor] = useState('');
    const factors = [
        'none',
        '1FA',
        '2FA'
    ]

    useEffect(() => {
        init();
    }, [props.content]);

    const init = () => {
        setDisabledAdd(true);
        setDisabledRem(true);
        if(props.content){
            if(props.content.rol){
                setRol(JSON.parse(JSON.stringify(props.content.rol)));
            }
            if(props.content.in){
                setInList(JSON.parse(JSON.stringify(props.content.in)));
            }
            if(props.content.ex){
                setExList(JSON.parse(JSON.stringify(props.content.ex)));
            }
            setSelectedIntent({});
            setDisabledEdit(true);
            setFactor('');
        }
    }

    const selectItem = (type, index) => {
        let list = [];
        if(type == 'ex'){
            list = exList;
            let inL = inList;
            list[index]['checked'] = list[index]['checked'] ? !list[index]['checked'] : true;
            setSelectedIntent(JSON.parse(JSON.stringify(list[index])));
            setFactor('');
            for(let i = 0; i<list.length; i++){
                if(i != index){
                    list[i]['checked'] = list[i]['checked'] ? !list[i]['checked'] : false;
                }
            }

            for(let i = 0; i<inL.length; i++){
                inL[i]['checked'] = false;
            }
            setExList(JSON.parse(JSON.stringify(list)));
            setInList(JSON.parse(JSON.stringify(inL)));
        }

        if(type == 'in'){
            list = inList;
            let exL = exList;
            list[index]['checked'] = list[index]['checked'] ? !list[index]['checked'] : true;
            setSelectedIntent(JSON.parse(JSON.stringify(list[index])));
            setFactor(list[index]['factor'][rol['uuid']] ? (list[index]['factor'][rol['uuid']] == 'pass' ? 'none' : list[index]['factor'][rol['uuid']]) : '');
            for(let i = 0; i<list.length; i++){
                if(i != index){
                    list[i]['checked'] = list[i]['checked'] ? !list[i]['checked'] : false;
                }
            }

            for(let i = 0; i<exL.length; i++){
                exL[i]['checked'] = false;
            }

            setInList(JSON.parse(JSON.stringify(list)));
            setExList(JSON.parse(JSON.stringify(exL)));
        }

        validate(type, list);
    }

    const validate = (type, list) => {
        let t = 0;
        for(let i = 0; i<list.length; i++){
            if(list[i]['checked']){
                t = 1;
                break;
            }
        }

        if(type == 'ex'){
            setDisabledRem(true);
            if(t){
                setDisabledAdd(false);
            }else{
                setDisabledAdd(true);
            }
        }

        if(type == 'in'){
            setDisabledAdd(true);
            if(t){
                setDisabledRem(false);
            }else{
                setDisabledRem(true);
            }
        }
    }

    const editIntent = async (type) => {
        props.changeLoader(true);
        let data = {
            key: selectedIntent['key'],
            action: type,
            
        };

        if(type == 'add'){
            data['roles'] = [
                {
                    uuid: rol['uuid'],
                    factor: factor ? factor : 'none'
                }
            ];
        }

        if(type == 'edit'){
            data['roles'] = [
                {
                    uuid: rol['uuid'],
                    factor: factor ? factor : 'none'
                }
            ]
        }

        if(type == 'delete'){
            data['roles'] = [rol['uuid']]
        }

        //console.log(data);
        let request = await API.service('updateIntents', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == "OK") {
            let req = await API.service('findIntents', {uuid: rol['uuid']}, props.pos, props.changeAlert, props.changeLoader, history);
            if (req.status == 200 && req.data.data.response == "OK") {
                let widg = [];
                widg = req.data.data.widget;
                if (widg[0].type == 'intentsConfig' && widg[0].content) {
                    let w = props.widgets[0];
                    let widgUpdate = [w, widg[0]];
                    props.changeWidgets(JSON.parse(JSON.stringify(widgUpdate)));
                }
            }
        }
        props.changeLoader(false);
    }

    const changeValue = (e) => {
        setFactor(e.target.value);
        if(selectedIntent['factor'] && selectedIntent['factor'][rol['uuid']]){
            setDisabledEdit(false);
        }
    }

    return <Paper sx={{width: '100%', marginTop: '1%'}}>
        <Typography
            component="div"
            children={
                <div className={classes.titleTable}>
                    <h2 className={classes.titleH2}>
                        <Settings className={classes.iconTitle}/>
                        <Typography component={'span'} fontWeight={'bold'} fontFamily={'Muli,sans-serif'} fontSize={'18px'}>
                            Intents {rol['name']}
                        </Typography>
                    </h2>
                </div>
            }
            fontWeight="bold"
            fontFamily="Muli,sans-serif"
            fontSize="20px"
        />

        <Grid container spacing={2} width={"auto"} sx={{marginLeft: '0px'}} mt={0}>
            <Grid item xs={3}>
                <Card>
                    <CardHeader 
                        sx={{px: 2, py: 1, width: '100%'}} 
                        title={
                            <Typography component={'span'} fontWeight="bold" fontFamily="Muli,sans-serif" fontSize="14px" >
                                Intents no agregados
                            </Typography>
                        }
                        subheader={
                            <Typography component={'div'} fontFamily="Muli,sans-serif" fontSize="14px" >
                                {`Total: ${exList.length}`}
                            </Typography>
                        }
                    />
                    <Divider/>
                    <List sx={{height: '300px', overflow: 'auto'}}>
                        {
                            exList.map((item, index) => {
                                return <ListItem key={`add-${index}`} sx={{padding: "4px 8px"}}>
                                    <ListItemIcon>
                                        <Checkbox checked={item.checked ? item.checked : false} onChange={selectItem.bind(this, 'ex', index)} color='secondary'/>
                                    </ListItemIcon>
                                    <ListItemText primary={item.key}/>
                                </ListItem>
                            })
                        }
                    </List>
                </Card>
            </Grid>
            <Grid item xs={1}>
                <Grid container direction="column" alignItems="center">
                    <Tooltip title="Agregar">
                        <IconButton color="secondary" disabled={disabledAdd} onClick={editIntent.bind(this, 'add')}>
                            <Add/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                        <IconButton color="secondary" disabled={disabledRem} onClick={editIntent.bind(this, 'delete')}>
                            <Remove/>
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
            <Grid item xs={3}>
                <Card>
                    <CardHeader 
                        sx={{px: 2, py: 1, width: '100%'}} 
                        title={
                            <Typography component={'span'} fontWeight="bold" fontFamily="Muli,sans-serif" fontSize="14px" >
                                Intents agregados
                            </Typography>
                        }
                        subheader={
                            <Typography component={'div'} fontFamily="Muli,sans-serif" fontSize="14px" >
                                {`Total: ${inList.length}`}
                            </Typography>
                        }
                    />
                    <Divider/>
                    <List sx={{height: '300px', overflow: 'auto'}}>
                        {
                            inList.map((item, index) => {
                                return <ListItem key={`delete-${index}`} sx={{padding: "4px 8px"}}>
                                    <ListItemIcon>
                                        <Checkbox checked={item.checked ? item.checked : false} onChange={selectItem.bind(this, 'in', index)} color='secondary'/>
                                    </ListItemIcon>
                                    <ListItemText primary={item.key}/>
                                </ListItem>
                            })
                        }
                    </List>
                </Card>
            </Grid>
            <Grid item xs={5} sx={{maxWidth: '48% !important'}}>
                <Card>
                    <CardHeader 
                        avatar={
                            <IconButton color="secondary" disabled={disabledEdit} onClick={editIntent.bind(this, 'edit')}>
                                <Edit/>
                            </IconButton>
                        }
                        sx={{px: 2, py: 1, width: '100%'}} 
                        title={
                            <Typography component={'span'} fontWeight="bold" fontFamily="Muli,sans-serif" fontSize="14px" >
                                Factor de autenticación
                            </Typography>
                        }
                    />
                </Card>
                <Divider/>
                <CardContent>
                    {
                        (!disabledAdd || !disabledRem) &&
                        <FormControl fullWidth sx={{marginTop: '10px'}}>
                            <InputLabel color='secondary' id="select-factor">Factor</InputLabel>
                            <Select value={factor} onChange={changeValue.bind(this)} color='secondary' labelId='select-factor' label="Factor">
                                {
                                    factors.map((item, index) => {
                                        return <MenuItem color='secondary' value={item} key={`option-${index}`}>{item}</MenuItem>
                                    }) 
                                }
                            </Select>
                        </FormControl>
                    }

                </CardContent>
            </Grid>
        </Grid>
    </Paper>
}

export default IntentsConfig;